module.exports = __webpack_public_path__ + "img/arrow_buyfeature_super.f2803897.png";